import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';

/**
 * Loads a catalogue from `public/i18n`. Scoped catalogues resolve to nested
 * paths — the `admin` scope in `es` becomes `i18n/admin/es.json` — so each
 * portal only downloads its own strings.
 */
@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(langOrScope: string) {
    return this.http.get<Translation>(`/i18n/${langOrScope}.json`);
  }
}
